import React from "react";
import styles from "./Hero.module.css";
import heroImage from "../../../assets/landing/hero 1 img.png";

const Hero = () => {
  return (
    <section className={ styles.hero }>
      <div className={ styles.heroContent }>
        <div className={ styles.textContent }>
          <h1 className={ styles.title }>
            <span className={ styles.highlight }>AI</span> Note-Taking & Conversation Intelligence Built <span className={ styles.highlight }>for Sales Teams</span>
          </h1>
          <p className={ styles.subtitle }>
            Capture every meeting, call, and in-person interaction. Turn them into <strong>summaries, insights & CRM updates</strong> — automatically
          </p>

          <a
            href="https://calendly.com/viraj-galile/30min"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className={ styles.ctaButton }>Book a Demo</button>
          </a>
        </div>
        <div className={ styles.imageContent }>
          <img src={ heroImage } alt="Hero Section" className={ styles.heroImage } />
        </div>
      </div>
    </section>
  );
};

export default Hero;